import React from "react";
import { Box, Typography, Divider, Link, makeStyles } from "@material-ui/core";
import theme from "../../theme/theme";
import * as styles from "../../theme/commonStyles";
import picture from "./../../images/kishore-pro.png";

import SkillsPage from "./SkillsPage";

const AboutPage = () => {
  const useStyles = makeStyles({
    columnDiv: {
      ...styles.columnDiv,
    },
    mainDiv: {
      width: "60%",
      [theme.breakpoints.down("sm")]: {
        width: "80%",
      },
      [theme.breakpoints.down("xs")]: {
        width: "90%",
      },
      margin: "0 auto",
    },
    headerText: {
      ...styles.headerText,
    },
    aboutText: {
      marginTop: "6rem",
    },
    divider: {
      ...styles.divider,
    },
    bodyText: {
      fontSize: "1.1rem",
      color: "black",
      maxWidth: "100%",
      maxHeight: "100%",
      margin: "1rem",
      lineHeight: "1.6rem",
    },
    link: {
      color: "black",
      textShadow: "1px 1px #1e6cae",
      textDecoration: "none",
      borderBottom: "1px solid #1e6cae",
      "&:hover": {
        color: "#1e6cae",
        cursor: "pointer",
      },
    },
    picture: {
      maxHeight: "100%",
      maxWidth: "100%",
      margin: "1rem",
      marginBottom: "6rem",
      width: "40%",
      [theme.breakpoints.down("md")]: {
        width: "50%",
      },
      [theme.breakpoints.down("sm")]: {
        width: "60%",
      },
      [theme.breakpoints.down("xs")]: {
        width: "70%",
      },
      boxShadow: "8px 8px 12px rgba(0, 0, 0, 0.25)",
    },
  });
  const classes = useStyles();

  const scrollToContact = () => {
    const element = document.getElementById("Contact");
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Box className={`${classes.columnDiv} ${classes.mainDiv}`} id="About">
        <Typography className={`${classes.aboutText} ${classes.headerText}`}>
          About
        </Typography>
        <Divider classes={{ root: classes.divider }} />
        <Typography className={classes.bodyText}>
          Hi there & welcome to my corner. This is <b>Kishore Shiraguppi</b>.
          Please read about my introduction & professional background. <br /> I
          bring over 20 years of dedicated experience in the software
          development industry. My career has been driven by a genuine passion
          for programming and a commitment to continuous learning. This
          enthusiasm has not only shaped my approach to technology but also
          instilled in me a robust work ethic and the ability to swiftly adapt
          to new technologies. Beyond my professional endeavors, I dedicate
          considerable time to staying abreast of the latest trends in business,
          technology, and software development. My expertise spans a diverse
          range of domains, including Banking, Finance, Wealth Management,
          Municipal Markets, Fixed Income, Logistics, Insurance, Enterprise
          Frameworks, Manufacturing, and Construction. Throughout my career, I
          have contributed to various application development teams in
          capacities ranging from a full-stack engineer to a team leader and
          technical architect. My aspiration is to further enrich my experience
          and contribute significantly in roles related to management,
          leadership, and development. I am keen on exploring opportunities
          where I can leverage my comprehensive background to drive innovation
          and excellence. Thank you for reading through this. I am looking
          forward to the possibility of contributing to your team and embracing
          the challenges and learning opportunities it offers. Warm regards to
          you. You can download{" "}
          <a
            href="/Kishore.Shiraguppi.CV.2024.pdf"
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            download
            style={{ textDecoration: "none" }} // Inline style for removing underline, adjust as needed
          >
            my detailed resume here.
          </a>
          {"  "}
          Also{" "}
          <Link
            onClick={scrollToContact}
            className={classes.link}
            underline="none"
          >
            my contact information &amp; links below here
          </Link>
          .
        </Typography>
        <Box
          component="img"
          src={picture}
          alt="Kishore Shiraguppi"
          className={classes.picture}
        />
      </Box>
      <SkillsPage />
    </div>
  );
};

export default AboutPage;
